import { DateTime } from 'luxon';

import { HostStatus } from '../../prtg-constants';

export class HostFlatNode
{
    depth: number;
    active: boolean;
    id: string;
    hostId: string;
    identifier: string;
    type: string;
    priority: number;
    status: string;
    codeStatus: string;
    statusMessage: string;
    isAcknowledged: boolean;
    name: string;
    displayName: string;
    address: string;
    lastValue: string;
    typeHost: string;
    kindHost: string;
    lastUpdateTime?: DateTime;
    tags: string;
    parentIdentifier: string;
    parentName: string;
    metaStatus: string;
    flagStatus: HostStatus;
    cumulativeFlagStatus: number;
    value?: number;

    public static mapperFromPrtg (source: any): HostFlatNode
    {
        const target = new HostFlatNode();
        target.metaStatus = source.status.toLowerCase();
        target.status = source.status;
        target.codeStatus = source.codeStatus;
        target.flagStatus = parseInt(HostStatus[source.status], 10);
        target.isAcknowledged = source.isAcknowledged;
        target.hostId = source.groupId;
        target.identifier = source.name;
        target.name = source.name;
        target.displayName = source.name;
        target.address = source.address;
        target.typeHost = source.categoryName;
        target.lastValue = source.outputText;

        return target;
    }
}
